'use client';

import { usePathname } from 'next/navigation';

import { HeadingFour } from '@/components/Typography/Heading';
import useEzShip from '@/helpers/hooks/useEzShip';
import { useAppContext } from '@/layouts/AppProvider';
import { useAppSelector } from '@/store';
import { useGetEzShipTitleQuery } from '@/store/api/ezShip';

function EzShipBanner() {
  const { ezShipId } = useEzShip();
  const { isBackOffice } = useAppContext();
  const { data } = useGetEzShipTitleQuery(
    { autoOrderId: ezShipId },
    { refetchOnMountOrArgChange: true, skip: !ezShipId?.length || isNaN(Number(ezShipId)) }
  );
  const ezShipTitleFromStore = useAppSelector(store => store.slices.ezShipSlice.ezShipTitle);
  const ezShipTitle = ezShipTitleFromStore || data?.data || '';
  if (typeof ezShipId === undefined || !ezShipId?.length || isNaN(Number(ezShipId))) return <></>;

  const headline = ezShipId === '0' ? `Create New EzShip: ${ezShipTitle}` : `Adding new item: ${ezShipTitle}`;

  return (
    <div className={isBackOffice ? 'main-dashboard-container mt-5' : 'mx-auto my-5 md:container'}>
      <HeadingFour className={isBackOffice ? 'px-0' : 'px-10'} variant="medium-gray">
        {headline}
      </HeadingFour>
    </div>
  );
}

export default function EzShipBannerWrapper() {
  const pathname = usePathname();
  return (
    <>
      <EzShipBanner key={pathname + Math.random()} />
    </>
  );
}
